<script setup lang="ts">
import { NTooltip } from 'naive-ui'
import { useAttrs } from 'vue'

withDefaults(defineProps<{
  trigger?: 'hover' | 'click' | 'focus' | 'manual'
  placement?: 'top' | 'top-start' | 'top-end' | 'right' | 'right-start' | 'right-end' | 'bottom' | 'bottom-start' | 'bottom-end' | 'left' | 'left-start' | 'left-end'
  showArrow?: boolean
  arrowPointToCenter?: boolean
  duration?: number
  delay?: number
  disabled?: boolean
  keepAliveOnHover?: boolean
  to?: string | HTMLElement
  displayDirective?: 'if' | 'show'
  show?: boolean
  onUpdateShow?: (show: boolean) => void
  onShow?: () => void
  onHide?: () => void
}>(), {
  trigger: 'hover',
  placement: 'top',
  showArrow: true,
  arrowPointToCenter: false,
  duration: 100,
  delay: 0,
  disabled: false,
  keepAliveOnHover: true,
  to: 'body',
  displayDirective: 'if',
  show: undefined,
})

const emit = defineEmits<{
  'update:show': [show: boolean]
  'show': []
  'hide': []
}>()

const attrs = useAttrs()

const onUpdateShow = (show: boolean) => {
  emit('update:show', show)
  if (show)
    emit('show')
  else
    emit('hide')
}
</script>

<template>
  <NTooltip
    :trigger="trigger"
    :placement="placement"
    :show-arrow="showArrow"
    :arrow-point-to-center="arrowPointToCenter"
    :duration="duration"
    :delay="delay"
    :disabled="disabled"
    :keep-alive-on-hover="keepAliveOnHover"
    :to="to"
    :display-directive="displayDirective"
    :show="show"
    v-bind="attrs"
    @update:show="onUpdateShow"
  >
    <template #trigger>
      <slot name="trigger" />
    </template>
    <template #default>
      <slot />
    </template>
  </NTooltip>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
